/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_TimecodeInputs */

const en_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert Timecode`)
};

const fr_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir le code temporel`)
};

const de_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcode konvertieren`)
};

const it_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertire il codice temporale`)
};

const ru_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразовать временной код`)
};

const es_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir código de tiempo`)
};

const zh_cn2_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换时间码`)
};

const ja_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードを変換`)
};

const hi_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड बदलें`)
};

const pt_pt2_convert_timecode = /** @type {(inputs: Convert_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter código de tempo`)
};

/**
* | output |
* | --- |
* | "Convert Timecode" |
*
* @param {Convert_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_timecode = /** @type {((inputs?: Convert_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_convert_timecode(inputs)
	if (locale === "de") return de_convert_timecode(inputs)
	if (locale === "it") return it_convert_timecode(inputs)
	if (locale === "ru") return ru_convert_timecode(inputs)
	if (locale === "es") return es_convert_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_convert_timecode(inputs)
	if (locale === "ja") return ja_convert_timecode(inputs)
	if (locale === "hi") return hi_convert_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_convert_timecode(inputs)
	return en_convert_timecode(inputs)
});